import {Disposable, Environment} from 'relay-runtime';
import {commitMutation, graphql} from 'react-relay';
import Util from '../../forecast-app/shared/util/util';
import {trackEvent} from '../../tracking/amplitude/TrackingV2';
import {UpdateGeneralTimeRegistrationSettingsInput} from './__generated__/UpdateGeneralTimeRegistrationSettingsMutation.graphql';

const mutation = graphql`
	mutation UpdateGeneralTimeRegistrationSettingsMutation($input: UpdateGeneralTimeRegistrationSettingsInput!) {
		updateGeneralTimeRegistrationSettings(input: $input) {
			timeRegistrationSettings {
				granularity
				allowDoneTasks
				allowProjects
				allowInternalTime
				allowBillableSplit
				allowRoles
				allowExceedingEstimate
				allowOutsideProjectDates
				allowOutsideTaskDates
				requireTaskAssignment
				requireNote
				strictMode
			}
		}
	}
`;

function getOptimisticResponse(input) {
	return {
		updateGeneralTimeRegistrationSettings: {
			timeRegistrationSettings: {
				id: input.id,
				granularity: undefined,
				allowDoneTasks: input.allowDoneTasks,
				allowProjects: input.allowProjects,
				allowInternalTime: input.allowInternalTime,
				allowBillableSplit: input.allowBillableSplit,
				allowRoles: input.allowRoles,
				allowExceedingEstimate: input.allowExceedingEstimate,
				allowOutsideProjectDates: input.allowOutsideProjectDates,
				allowOutsideTaskDates: input.allowOutsideTaskDates,
				requireTaskAssignment: input.requireTaskAssignment,
				requireNote: input.requireNote,
				strictMode: input.strictModeks,
			},
		},
	};
}

function commit(
	environment: Environment,
	input: UpdateGeneralTimeRegistrationSettingsInput,
	onSuccess?: (response) => void,
	onError?: (error: Error) => void
): Disposable {
	trackEvent('Time Registration Settings', 'General Settings Updated', input);

	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}};

	return commitMutation(environment, {
		mutation,
		variables,
		optimisticResponse: getOptimisticResponse(input),
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
